export default class Anchor {
    static init(): void {
        const anchors = document.querySelectorAll<HTMLElement>('[data-nav-anchor]');

        if (anchors.length === 0) {
            return;
        }

        anchors.forEach((anchor) => {
            anchor.addEventListener('click', (e: Event) => {
                e.preventDefault();

                // Získej hodnotu z data atributu
                const targetId = anchor.getAttribute('data-nav-anchor');

                if (!targetId) {
                    return;
                }

                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    // Získej výšku fixního menu
                    const fixedNav = document.querySelector<HTMLElement>('.base-nav');
                    const navHeight = fixedNav ? fixedNav.offsetHeight : 0;

                    // Vypočítej pozici cílového elementu mínus výška menu
                    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - navHeight;

                    // Plynulý scroll
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth',
                    });
                }
            });
        });
    }
}
